import Interactions from "../interactions";
import AgoraChat from "../agora-chat";
import AgoraStream from "../agora-live";
import { VerbLogo, Hussle_Logo } from "../../assets/icons";
import { useEffect, useState } from "react";
import { axios } from "../../api/axios";
import useAppAccessor from "../../hooks/useappAccessor";
import useAppDispatch from "../../hooks/useAppDispatch";
import { setClient, setUserData } from "../auth/Login/login.actions";
import {
  callRepsiteAPI,
  callConfigurationAPI,
  callCreateStreamAPI,
  callGetRTMToken,
} from "../../services/main.service";
import {
  setRepsiteData,
  setConfigurationData,
  setCreateStreamData,
  setRTMToken,
} from "./livemain.actions";
import useAppNavigation from "../../hooks/useAppNavigation";
import { RemoteConfigService } from "../../helper/RemoteConfigService";
import Loader from "../../components/loader";
import { getPreviousInteractions } from "../../services/record.service";
import { setInteractionData } from "../interactions/interaction.actions";
import { toast } from "react-toastify";

const LiveMain = (props: any) => {
  const configValues = RemoteConfigService();
  const dispatch = useAppDispatch();
  const { getLiveMainData } = useAppAccessor();
  const { joinWithAttendeeData } = getLiveMainData();
  const { navigate } = useAppNavigation();
  const [showLoader, setShowLoader] = useState(false);
  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
  // const  { user } = getUserData();
  const { getUserData } = useAppAccessor();
  const { language } = getUserData();

  const isHost = () => {
    return window.location.href.indexOf("/stream") > -1;
  };

  const getUserInfo = async () => {
   // console.log("called API===>", "GET user INFO");
    await axios
      .get("/stream/authenticate")
      .then((response: any) => {
        if (response.publicUserData != null) {
          checkBrand(response?.publicUserData?.company_name);

          if (response.publicUserData!.clientId.indexOf("oauth") > -1) {
            response!.publicUserData!.isCRMUser = false;
          } else {
            response!.publicUserData!.isCRMUser = true;
          }
          if (response.publicUserData!.clientId.indexOf("repsites") > -1) {
            response!.publicUserData!.isMAUser = true;
          } else {
            response!.publicUserData!.isMAUser = false;
          }

          if (response.publicUserData!.company_name.indexOf("Ambit Energy") > -1 ||
          response.publicUserData!.company_name.indexOf("Arieyl") > -1 ||
          response.publicUserData!.company_name.indexOf("ovvi") > -1 ||
          response.publicUserData!.company_name.indexOf("eexcelusa") > -1
        ) {
            response!.publicUserData!.isMAUser = false;
          }
        }
        dispatch(setUserData(response));
        handleRepsiteAPICall(response.publicUserData.userId);
      })
      .catch((err: any) => {
        setShowLoader(false);

        const errorMessage = "Something went wrong. Please login again.";
        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
            fontSize: "16px",
            padding: "20px 30px",
          },
        });
        console.error("Authentication error:", err);
      });
  };

  const checkBrand = (client: any) => {
    return dispatch(setClient(client));
  };

  useEffect(() => {
    if (isHost() === true) {
      setShowLoader(true);
      getUserInfo();
    }
  }, []);

  useEffect(() => {
    if (isHost() === false) {
      callGetRTMToken(joinWithAttendeeData.stream_id, false)
        .then((resp) => {
          dispatch(setRTMToken(resp));
         // console.log("RTMToken=====>", resp);
        })
        .catch((err) => {
         // console.log("RTMToken====>Err", err);
        });
    }
  }, [joinWithAttendeeData]);

  const handleRepsiteAPICall = (userId: any) => {
    callRepsiteAPI(userId)
      .then((data: any) => {
        dispatch(setRepsiteData(data));
        handleConfigurationAPICall(data.stream_configuration.stream_id);
        navigate({ screen: "/stream/" + data.stream_configuration.stream_id });
      })
      .catch((err) => {
        setShowLoader(false);
       // console.log("repsiteAPICall===ERROR", err);
      });
  };

  const handleConfigurationAPICall = (steramId: any) => {
   // console.log("steramId====>", steramId);
    handleCreateStreamAPICall(steramId);
    callConfigurationAPI(steramId)
      .then((resp) => {
        dispatch(setConfigurationData(resp));
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
       // console.log("configurationResp====>Err", err);
      });
  };

  const handleCreateStreamAPICall = (steramId: any) => {
    getPreviousInteractions(steramId)
      .then((data: any) => {
        data.interactions.map((item: any) => {
          item.attributes.shouldShow = false;
        });
       // console.log("previousInteractions====>", data.interactions);
        dispatch(setInteractionData(data.interactions));
      })
      .catch((err: any) => {});
  };

  return (
    <div
      className={
        isMobile
          ? "flex h-screen w-full bg-gradient-to-b from-[#1C1C1C] to-[#272626] items-center justify-center"
          : "flex h-screen w-full bg-gradient-to-b from-[#1C1C1C] to-[#272626] items-center justify-center py-12"
      }
      style={
        isMobile
          ? { paddingTop: "30%" }
          : { paddingLeft: "5%", paddingRight: "5%" }
      }
    >
      {/* <span className="text-white font-bold text-lg">
          Hi this is Live Main page
        </span> */}

      {isMobile ? (
        <div className="flex-col w-full h-full ">
          <div
            className="w-full h-full  rounded grid  divide-x-2 divide-current"
            style={{ backgroundColor: "#0B0B0B", padding: 0 }}
          >
            {/* <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#414141",
                opacity: 1,
              }}
              id="agoraChatContainer"
            >
              <AgoraChat></AgoraChat>
            </div> */}
            {/* //block above because chat will move to bottom modal */}
            <div
              className="w-full h-full"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#272626",
              }}
            >
              <AgoraStream></AgoraStream>
            </div>

            {/* <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: "#414141", opacity:1 }}>
            <Interactions></Interactions>
          </div> */}
          </div>
        </div>
      ) : (
        <div className="flex-col w-full h-full">
          <div
            className="w-full h-full rounded-lg grid overflow-hidden"
            style={{ 
              backgroundColor: "#0A0A0A", 
              padding: 3,
              gridTemplateColumns: "25% 50% 25%",
              boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.05)"
            }}
          >
            {!isMobile && (
              <div 
                style={{ 
                  backgroundColor: "#1F1F1F",
                  borderRadius: "8px 0 0 8px"
                }} 
                id="agoraChatContainer"
                className="border-r border-[#2A2A2A]"
              >
                <AgoraChat></AgoraChat>
              </div>
            )}
            <div 
              style={{ 
                backgroundColor: "#151515",
                borderRadius: isMobile ? "8px" : "0"
              }}
              className="relative overflow-hidden"
            >
              <AgoraStream></AgoraStream>
            </div>
            <div 
              style={{ 
                backgroundColor: "#1F1F1F",
                borderRadius: "0 8px 8px 0"
              }}
              className="border-l border-[#2A2A2A]"
            >
              <Interactions></Interactions>
            </div>
          </div>
          <div className="flex w-full items-center justify-center mt-3 opacity-60 hover:opacity-100 transition-opacity">
            <span className="text-[10px] text-[#8D8D8E] font-light">Powered by</span>
            <img src={Hussle_Logo} width={65} className="ml-1.5 mt-[-2px] opacity-80"></img>
          </div>
        </div>
      )}

      {showLoader && (
        <Loader message={language['please_wait']} isShowLoader={showLoader}></Loader>
      )}
    </div>
  );
};

export default LiveMain;
